export const organization = {
  state: {},
  reducers: {
    update(state, organizationData) {
      return Object.assign({}, state, organizationData);
    },
  },
  effects: {
    setOrganization(organization, rootState) {
      this.update(organization);
    },
  },
};
